if(document.querySelector('.scroll-down')){
    let divScrollDown = document.querySelector('.scroll-down');
    divScrollDown.addEventListener('click', function () {
        window.scrollBy(0, 350);
    });
}